import {Injectable} from '@angular/core';
import {Subscription} from 'rxjs';
import {IMqttMessage, IMqttServiceOptions, IPublishOptions, MqttService} from 'ngx-mqtt';
import {IClientSubscribeOptions} from 'mqtt/types/lib/client-options';

@Injectable()
export class LinkMqttService {
  private curSubscription: Subscription | undefined;
  // ENG-4418: Track broker-event subscriptions so createConnection() can be called
  // safely more than once without stacking duplicate onConnect/onError/onMessage handlers.
  private onConnectSub: Subscription | undefined;
  private onErrorSub: Subscription | undefined;
  private onMessageSub: Subscription | undefined;
  connection = {
    hostname: 'priser.labrador.ai',
    port: 1883,
    path: '/link',
    clean: true,
    connectTimeout: 4000,
    reconnectPeriod: 4000,
    clientId: 'mqttx_597046f4',
    username: 'priser',
    password: 'fweiPX6csDNnR3XxaAAxNvxu',
    protocol: 'ws',
  };
  subscription = {
    topic: 'topic/mqttx',
    qos: 0,
  };
  publish = {
    topic: 'topic/browser',
    qos: 0,
    payload: '{ "msg": "Hello, I am browser." }',
  };
  receiveNews = '';
  client: MqttService ;
  isConnection = false;
  subscribeSuccess = false;

  createConnection() {
    try {
      this.client.connect(this.connection as IMqttServiceOptions);
    } catch (error) {
    }

    // ENG-4418: Unsubscribe previous broker-event handlers before re-subscribing.
    // Calling createConnection() multiple times previously stacked duplicate handlers
    // causing each event callback to be invoked more than once.
    if (this.onConnectSub) { this.onConnectSub.unsubscribe(); }
    if (this.onErrorSub) { this.onErrorSub.unsubscribe(); }
    if (this.onMessageSub) { this.onMessageSub.unsubscribe(); }

    this.onConnectSub = this.client.onConnect.subscribe(() => {
      this.isConnection = true;
    });

    this.onErrorSub = this.client.onError.subscribe((error: any) => {
      this.isConnection = false;
    });

    this.onMessageSub = this.client.onMessage.subscribe((packet: any) => {
      this.receiveNews = this.receiveNews.concat(packet.payload.toString());
    });
  }

  doSubscribe() {
    const { topic, qos } = this.subscription;
    this.curSubscription = this.client.observe(topic, { qos } as IClientSubscribeOptions).subscribe((message: IMqttMessage) => {
      this.subscribeSuccess = true;
    });
  }

  doUnSubscribe() {
    this.curSubscription.unsubscribe();
    this.subscribeSuccess = false;
  }

  doPublish() {
    const { topic, qos, payload } = this.publish;
    this.client.unsafePublish(topic, payload, { qos } as IPublishOptions);
  }

  destroyConnection() {
    try {
      this.client.disconnect(true);
      this.isConnection = false;
    } catch (error) {
    }
  }
}
